import { ReactNode, useEffect } from "react";

interface DrawerProps {
  show: boolean;
  onClose: () => void;
  wide?: boolean;
  title: ReactNode;
  subtitle?: ReactNode;
  // optional element shown left of the title (avatar, icon)
  lead?: ReactNode;
  footer?: ReactNode;
  tintBody?: boolean;
  children: ReactNode;
}

// Right-side slide-in panel. Render it inside a .cx page wrapper.
const Drawer = ({ show, onClose, wide, title, subtitle, lead, footer, tintBody, children }: DrawerProps) => {
  useEffect(() => {
    if (!show) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [show, onClose]);

  if (!show) return null;
  return (
    <>
      <div className="cx-scrim" onClick={onClose}></div>
      <aside className={`cx-drawer ${wide ? "wide" : ""}`} role="dialog" aria-modal="true">
        <div className="cx-dr-head">
          {lead}
          <div style={{ minWidth: 0 }}>
            <b>{title}</b>
            {subtitle && <div className="fs12 muted">{subtitle}</div>}
          </div>
          <button type="button" className="x" onClick={onClose} aria-label="Close"><i className="ri-close-line"></i></button>
        </div>
        <div className={`cx-dr-body ${tintBody ? "tint" : ""}`}>{children}</div>
        {footer && <div className="cx-dr-foot">{footer}</div>}
      </aside>
    </>
  );
};

export default Drawer;
